import { Dispatch, SetStateAction } from "react";
import { Toast } from "./Toast";

export type ToastMessage = {
    title: string;
    message: string;
    toastType: "error" | "success" | "warning";
}

export function ToastArea( { toastMessages, setToastMessages }: { toastMessages: ToastMessage[], setToastMessages: Dispatch<SetStateAction<ToastMessage[]>> } ) {
    return (
        <div className="fixed right-0 top-0 m-2 z-10 mt-16">
            {toastMessages.map((toast, index) => (
                <Toast key={index} title={toast.title} message={toast.message} toastType={toast.toastType} onCloseClick={() => {
                    const newToasts = toastMessages.filter(t => t !== toast);
                    setToastMessages([...newToasts]);
                }} />
            ))}
        </div>
    )
}